// Both apps: /bookings/:bookingId[/tab].
const booking =
  (tab = '') =>
  ([bookingId]) =>
    `/bookings/${bookingId}${tab}`;

const urlMappings = {
  to: {
    // Trip URLs
    'trip-designer.library.drafts': (ids) =>
      `/trip-designer/design-trip/${ids[0]}?from=draftEdit`,
    'trip-designer.library.trips': (ids) =>
      `/trip-designer/design-trip/${ids[0]}?from=draftEdit`,

    'trips.chat': (ids) => `/trips/${ids[0]}/chat`,

    // Folder URLs
    'folders.show': (ids) => `/folders/${ids[0]}`,

    // Dmc URLs
    'dmcs.index': (_ids) => `/dmcs`,

    // Booking URLs. The tour operator spells the history tab `histories`.
    'bookings.show': booking(),
    'bookings.chat': booking('/chat'),
    'bookings.documents': booking('/documents'),
    'bookings.adjustment': booking('/adjustment'),
    'bookings.history': booking('/histories'),
  },
  dmc: {
    // Trip URLs
    'trip-designer.library.drafts': (ids) =>
      `/trip-designer/library/drafts/${ids[0]}`,
    'trip-designer.library.trips': (ids) =>
      `/trip-designer/library/trips/${ids[0]}`,
    'trip-designer.library.trips.history': (ids) =>
      `/trip-designer/library/trips/${ids[0]}/history`,
    'trips.chat': (ids) => `/trip-designer/library/drafts/${ids[0]}/chat`,

    // Booking URLs
    'bookings.show': booking(),
    'bookings.chat': booking('/chat'),
    'bookings.documents': booking('/documents'),
    'bookings.adjustment': booking('/adjustment'),
    'bookings.history': booking('/history'),

    // Connection request URLs
    'to-connection-requests.hotels.show': (ids) =>
      `/to-connection-request/connections/${ids[0]}/hotels`,
    'to-connection-requests.experiences.show': (ids) =>
      `/to-connection-request/connections/${ids[0]}/experiences`,
    'to-connection-requests.templates.show': (ids) =>
      `/to-connection-request/connections/${ids[0]}/templates`,
    // Contract Urls
    'contracts.show': (ids) => `/hotels/catalog/${ids[0]}/contracts/${ids[1]}`,

    // Hotel Urls
    'hotels.show': (ids) => `/hotels/catalog/${ids[0]}`,

    //Organization
    'organizations.conditions': (ids) =>
      `/organizations/${ids[0]}/edit/conditions`,
  },
};

export default function getActionUrl(action, navigate, scope) {
  const { url, ids } = action;

  if (!action || !url || url === '#') {
    console.warn('Action url is not defined', action);
    return;
  }

  if (url.startsWith('http')) {
    return url;
  }

  try {
    const scopeMappings = urlMappings[scope];
    if (!scopeMappings) {
      console.warn(
        `No URL mappings found for action: ${url} in scope: ${scope}`,
      );
      return;
    }

    // An action with no ids has nothing to point at, and building the path
    // anyway produced links ending in `undefined`.
    if (!ids?.length) {
      console.warn(`No ids for action: ${url} in scope: ${scope}`);
      return;
    }

    if (ids.some((id) => Number.isNaN(parseInt(id)))) {
      console.warn(`Invalid IDs for action: ${url} in scope: ${scope}`, ids);
      return;
    }

    const urlGenerator = scopeMappings[url];
    if (!urlGenerator) {
      console.warn(
        `No URL generator found for action: ${url} in scope: ${scope}`,
      );
      return;
    }

    return urlGenerator(ids);
  } catch (error) {
    console.warn('Error generating action URL', action, error);
  }
}
